import { Trans, useLingui } from '@lingui/react/macro';
import React, { useRef } from 'react';
import { useDismissibleLayer } from '../hooks/useDismiss';

interface ConfirmDeleteModalProps {
  channelName: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

export default function ConfirmDeleteModal({
  channelName,
  onConfirm,
  onCancel,
  loading,
}: ConfirmDeleteModalProps) {
  const { t, i18n } = useLingui();
  const overlayRef = useRef<HTMLDivElement>(null);

  // The modal stays on the stack while the delete is in flight — Escape must
  // not fall through to what the modal covers — but it stops acting on the key,
  // because the request it would be cancelling has already gone out.
  useDismissibleLayer({
    active: true,
    within: overlayRef,
    onEscape: loading ? undefined : onCancel,
  });

  return (
    <div
      ref={overlayRef}
      className="modal-overlay"
      style={{ zIndex: 1100 }}
      onClick={loading ? undefined : onCancel}
    >
      <div className="modal-content confirm-delete-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            <Trans>Delete channel</Trans>
          </h3>
        </div>
        <div className="modal-body">
          <p className="confirm-delete-text">
            <Trans>
              Delete <strong>#{channelName}</strong>? This cannot be undone.
            </Trans>
          </p>
          <div className="form-actions confirm-delete-actions">
            <button className="btn btn-sm" onClick={onCancel} disabled={loading}>
              <Trans>Cancel</Trans>
            </button>
            <button className="btn btn-sm btn-danger" onClick={onConfirm} disabled={loading}>
              {loading ? t`Deleting…` : t`Delete`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
